/**
 * Central catalog of permission codes matching backend Permissions.cs
 * All permission strings follow the pattern: resource.action or resource.sub-resource.action
 */

export const PERMISSIONS = {
  // Accounts
  Accounts: {
    Read: "accounts.read",
    Write: "accounts.write",
  },

  // Attachments
  Attachments: {
    Redirect: "attachments.redirect",
    FullRedirect: "attachments.full-redirect",
  },

  // Budgets
  Budgets: {
    Read: "budgets.read",
    Write: "budgets.write",
    Approve: "budgets.approve",
  },

  // Crew
  Crew: {
    Read: "crew.read",
    Write: "crew.write",
    Approve: "crew.approve",
    Medical: {
      Read: "crew.medical.read",
      Write: "crew.medical.write",
    },
  },

  // Currencies
  Currencies: {
    Read: "currencies.read",
    Write: "currencies.write",
  },

  // Expenses (covers transactions, invoices, suppliers)
  Expenses: {
    Read: "expenses.read",
    Write: "expenses.write",
  },

  // Maintenance
  Maintenance: {
    Read: "maintenance.read",
    Assignment: {
      Write: "maintenance.assignment.write",
    },
    Execution: {
      Write: "maintenance.execution.write",
    },
    Management: {
      Write: "maintenance.management.write",
    },
    RunningHours: {
      Write: "maintenance.running-hours.write",
    },
  },

  // Organizations
  Organizations: {
    Read: "organizations.read",
    Write: "organizations.write",
  },

  // Settings
  Settings: {
    Read: "settings.read",
    Write: "settings.write",
  },

  // Subscriptions
  Subscriptions: {
    Read: "subscriptions.read",
    Write: "subscriptions.write",
  },

  // Users
  Users: {
    Read: "users.read",
    Write: "users.write",
  },

  // Vessels
  Vessels: {
    Read: "vessels.read",
    Write: "vessels.write",
    Permission: {
      Manage: "vessels.permission.manage",
    },
  },

  // Roles
  Roles: {
    Read: "roles.read",
    Write: "roles.write",
  },
} as const;
